export function resolvePath(
	obj: unknown,
	path: string
): string | undefined {
	return path
		.split(".")
		.reduce<any>((acc, key) => (acc == null ? acc : acc[key]), obj);
}
